import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faListMusic } from '@fortawesome/pro-light-svg-icons/faListMusic';
import { faNewspaper } from '@fortawesome/pro-light-svg-icons/faNewspaper';
import { faEnvelopeOpenText } from '@fortawesome/pro-light-svg-icons/faEnvelopeOpenText';
import { faRadio } from '@fortawesome/pro-light-svg-icons/faRadio';
import { faPodcast } from '@fortawesome/pro-light-svg-icons/faPodcast';
import { faVideo } from '@fortawesome/pro-light-svg-icons/faVideo';
import { faUsers } from '@fortawesome/pro-light-svg-icons/faUsers';
import clsx from 'clsx';
import type { OutreachTargetKind } from 'fym-shared/src/music24/outreach/types';
import { TypedMemo } from '../../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for Outreach; each part uses its own slice of it */
import shared from '../Outreach.module.scss';
/* eslint-enable css-modules/no-unused-class */

const KIND_ICONS: Record<OutreachTargetKind, IconDefinition> = {
  playlist: faListMusic,
  press: faNewspaper,
  newsletter: faEnvelopeOpenText,
  radio: faRadio,
  podcast: faPodcast,
  creator: faVideo,
  community: faUsers,
};

interface TargetCoverProps {
  imageUrl: string | null;
  kind: OutreachTargetKind;
  className: string | undefined;
}

/**
 * The picture of a target. A target with no picture (the demo targets, most outlets) or a picture
 * that does not load (an expired service address) shows the icon of its kind, not an empty box.
 */
const TargetCoverComponent: React.FC<TargetCoverProps> = ({ imageUrl, kind, className }) => {
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  if (imageUrl !== null && imageUrl !== failedUrl) {
    return <img className={className} src={imageUrl} alt="" onError={() => setFailedUrl(imageUrl)} />;
  }
  return (
    <span className={clsx(className, shared.coverIcon)} aria-hidden>
      <FontAwesomeIcon icon={KIND_ICONS[kind]} />
    </span>
  );
};

export const TargetCover = TypedMemo(TargetCoverComponent);
